var exports = {
  "ZH": "GuildBadge.module__badgeWrapper___WVVuLV",
  "k3": "GuildBadge.module__badgeRow___WVVuLV",
  "ZY": "GuildBadge.module__customBadge___WVVuLV",
  "uk": "GuildBadge.module__customBadgeTooltip___WVVuLV",
  "n6": "GuildBadge.module__customBadgeTooltipName___WVVuLV",
  "qS": "GuildBadge.module__badge___WVVuLV",
  "eT": "GuildBadge.module__badgeOnLightSurface___WVVuLV",
  "YW": "GuildBadge.module__badgeBanner___WVVuLV",
  "e$": "GuildBadge.module__badgeBannerDark___WVVuLV",
};

module.exports = exports;
